import { CalendarX2, CheckCircle2, CircleAlert, CloudUpload, Hourglass, SendHorizontal } from 'lucide-react';
import type { SchrittArt } from '../../lib/planung';

/** Kurzes Etikett und Symbol je Art des nächsten Schritts (auch für die Legende). */
export const SCHRITT_INFO: Record<SchrittArt, { label: string; Icon: typeof CheckCircle2 }> = {
  erledigt:      { label: 'Erledigt',      Icon: CheckCircle2 },
  versandbereit: { label: 'Versandbereit', Icon: SendHorizontal },
  brevo:         { label: 'Brevo',         Icon: CloudUpload },
  termin:        { label: 'Termin',        Icon: CalendarX2 },
  handeln:       { label: 'Zu tun',        Icon: CircleAlert },
  warten:        { label: 'Wartet',        Icon: Hourglass },
};
